import { render, staticRenderFns } from "./BPAccountsPayableModule.vue?vue&type=template&id=3dae502a&"
import script from "./BPAccountsPayableModule.vue?vue&type=script&lang=js&"
export * from "./BPAccountsPayableModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports